__turbopack_context__.v({
  "className": "poppins_104fb117-module__jlXMGa__className",
  "variable": "poppins_104fb117-module__jlXMGa__variable",
});
